var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CampaignService } from '../../services/campaign/campaign.service';
import { UserService } from '../../services/user.service';
import { MentionService } from '../../services/mention/mention.service';
import { apiEndpoints } from '../../app.constants';
import { CampaignInfluencerStatus, CampaignsDetailComponent, CampaignTab, TermActionType } from './campaign-detail.component';
import { Location as NgCommonLocation } from '@angular/common';
import { ModalService } from '../../services/modal/modal.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { Campaign } from '../../../models/campaign';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { WebUtils } from '../../utils/web.utils';
import { EventTrackerService, Page, UserActionType, ActivePages, ActionSource, TargetType } from '../../services/event-tracker/event-tracker.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { CacheService } from '../../services/cache/cache.service';
var CampaignsAddComponent = /** @class */ (function (_super) {
    __extends(CampaignsAddComponent, _super);
    function CampaignsAddComponent(router, activatedRoute, translate, campaignService, groupService, userService, mentionService, modalService, validateErrorHandler, referenceDataService, location, eventTracker, cacheService) {
        var _this = _super.call(this, router, activatedRoute, translate, campaignService, groupService, userService, mentionService, modalService, validateErrorHandler, referenceDataService, eventTracker, cacheService, translate.instant('campaigns.new_campaign.title')) || this;
        _this.location = location;
        return _this;
    }
    CampaignsAddComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.sub = this.activatedRoute.params.subscribe(function (params) {
            _this.tabKey = params['tab-key'] || CampaignTab.TERMS;
        });
        this.sendViewEvent();
    };
    CampaignsAddComponent.prototype.getAddTerms = function () {
        var _this = this;
        var selectedTerms = this.selectedCampaignTerms;
        var addTerms = selectedTerms
            .map(function (x) {
            return {
                termId: x.id,
                action: TermActionType.ADD,
                params: x.hasParams ? _this.extractParams(x.params) : null
            };
        });
        return addTerms;
    };
    CampaignsAddComponent.prototype.getAddFiles = function () {
        return this.materialImages
            .filter(function (x) { return x.action === 'add'; })
            .map(function (x) {
            var imageLink = apiEndpoints.getUploadFile + '/' + x.id;
            return {
                id: x.id,
                name: x.name,
                thumbnail: imageLink,
                $$hashKey: '',
                fileId: x.id,
                contentType: x.contentType,
                action: 'add',
                downloadLink: imageLink
            };
        });
    };
    CampaignsAddComponent.prototype.replaceTabState = function (tabKey) {
        this.tabKey = tabKey;
        var params = {
            queryParams: {
                activeAccount: WebUtils.extractActiveAccountFromUrl()
            }
        };
        var url = this.router.createUrlTree(['/campaigns-add', tabKey || CampaignTab.TERMS], params);
        this.location.replaceState(url.toString());
    };
    /**
     * handle to create a new campaign
     */
    CampaignsAddComponent.prototype.createOrUpdateCampaign = function () {
        var _this = this;
        this.isSavingCampaign = true;
        var campaignSaveData = {
            name: this.campaignName,
            projectType: 'CAMPAIGN_CREATION',
            brief: this.campaignBrief,
            additionalInfo: this.campaignAdditionalInfo,
            keywordIds: this._mentions.map(function (x) { return x.id; }),
            terms: this.getAddTerms(),
            influencerIds: this.campaignInfluencers.filter(function (influencer) {
                return (influencer.campaign_influencer_status !== CampaignInfluencerStatus.NEW || !influencer.is_accepted);
            })
                .map(function (influencer) { return influencer.influencer_id; }),
            advertiserID: this.userService.getCompanyId(),
            needSendEmail: true,
            files: this.getAddFiles()
        };
        this.campaignService.addNewCampaign(campaignSaveData)
            .subscribe(function (resp) {
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: resp.id,
                name: _this.campaignName,
                type: Page.CAMPAIGN
            }, __assign({ action: UserActionType.CREATE, source: ActionSource.PAGE }, campaignSaveData), undefined, {
                type: ActivePages.CAMPAIGN_NEW,
                name: _this.campaignName,
                id: resp.id
            });
            _this.eventTracker.trackUserAction(UserActionType.CHAM_CAMPAIGN_CREATE);
            _super.prototype.addNewAcceptedToCampaign.call(_this, resp.id, _this.campaignInfluencers, function () { _this.isSavingCampaign = false; });
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (err) {
            _this.isSavingCampaign = false;
            if (err.error.data === 'invalid_level') {
                _this.hasInvalidAccountLevelError = true;
                _this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
                _super.prototype.sendInvalidActionToSegement.call(_this, _this.groupService.extractLimitInfoFromErrorMessage(err.error.message, _this.campaignInfluencers.length, _this.userService.maxCampaignInfluencers, true), {
                    campaign_id: 0,
                    campaign_name: _this.campaignName,
                    influencers: campaignSaveData.influencerIds
                });
            }
            else {
                return _this.handleSaveError(err);
            }
        });
    };
    CampaignsAddComponent.prototype.isCampaignDataChanged = function () {
        var hasChangeName = this.campaignName !== '';
        var hasChangeBrief = this.campaignBrief !== '';
        return this.isDirtyCampaignData || hasChangeName || hasChangeBrief;
    };
    CampaignsAddComponent.prototype.getCampaign = function () {
        var newCampaign = new Campaign();
        newCampaign.id = 0;
        return newCampaign;
    };
    CampaignsAddComponent.prototype.getCampaignCachingKeys = function () {
        return [];
    };
    CampaignsAddComponent.prototype.sendViewEvent = function () {
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN_SETTING, {
            type: TargetType.CAMPAIGN
        }, {
            source: ActionSource.PAGE,
            actionDetails: ActivePages.CAMPAIGN_NEW
        }, undefined, undefined);
    };
    return CampaignsAddComponent;
}(CampaignsDetailComponent));
export { CampaignsAddComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-add.component.ts.pre-build-optimizer.js